import { observable } from "@/util/observable.mjs";
import makeStrictKeysObject from "@/util/strict-keys-object.mjs";

// Refs used across LoL.
const refs = makeStrictKeysObject({
  inGameState: null,

  rustBE: {
    playerAPIsEnabled: false,
    mutationsEnabled: true,
  },

  // in game features are separate ref from in-game-state
  inGameFeatures: observable({
    content: null,
    buildOption: null,
    enabled: false,
    videoAd: null,
  }),

  lolClient: null,

  onEnterChampionSelect: () => null,
  onBeginPostmatchTransition: () => null,

  // postmatch
  PostMatchLayout: null,
  PostMatchJunglePathing: (_props) => null,
  PostMatchCoachingSection: null,
  PostMatchDevSection: null,

  // routes
  lolChampionsPrefix: "lol/champions",
  lolChampionPrefix: "lol/champions",
  lolTierlistPrefix: "lol/tierlist",
});

export default refs;
